import Moment from 'moment';
export function waitingSince(date, append = null) {
    let since = Moment(date);
    let now = Moment();
    function doAppend(str) {
        if (append) {
            return str + ' ' + append;
        }
        return str;
    }
    if (now.diff(since, 'minutes') < 1) {
        return 'Just Now';
    }
    if (now.diff(since, 'minutes') < 60) {
        return doAppend(now.diff(since, 'minutes') + ' mins');
    }
    if (now.diff(since, 'hours') < 24) {
        return doAppend(now.diff(since, 'hours') + ' hours');
    }
    if (now.diff(since, 'days') < 30) {
        return doAppend(now.diff(since, 'days') + ' days');
    }
    return since.format('MMM DD');
}
